import useOnClickOutside from "@/hooks/useOnClickOutside";
import { useRef, useState } from "react";

export default function Dropdown({ options, selectedOption, defaultValue, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useOnClickOutside([ref], () => setOpen(false));

  return (
    <div className="relative">
      <div
        onClick={() => setOpen(!open)}
        className="inline-flex items-center relative cursor-pointer h-6 z-0 rounded-md border bg-white"
      >
        <p
          className="border-e max-h-4 flex justify-center items-center px-4 py-2 text-sm/none text-gray-600 w-6 hover:bg-gray-50 z-0 hover:text-gray-700"
        >
          {selectedOption?.label || defaultValue?.label}
        </p>

        <button className="h-full flex justify-center items-center w-4 text-gray-600 z-0 hover:bg-gray-50 hover:text-gray-700">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {open && (
        <div
          className="absolute start-0 z-[5000] overflow-scroll max-h-32 mt-2 w-16 rounded-md border border-gray-100 bg-white shadow-lg"
          role="menu"
          ref={ref}
        >
          {options.map((option, i) => (
            <p
              key={i}
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
              className="block rounded-lg px-4 py-2 cursor-pointer text-sm text-center text-gray-500 active:bg-gray-200 hover:text-gray-700"
              role="menuitem"
            >
              {option.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
